import React from "react";
import PropTypes from "prop-types";
import { NotWebRegister } from "../../CommonComponents/style";
import { 
	ProfileSectionHeading,
	DetailsContainer,
	IconContainer,
	DetailsData,
	ProfileInformationHeading,
	UserContributionDetails
} from  "../../../Epics/MyAccounts/styles";
import Profile from "../../../CommonComponents/svgs/Profile";
import {isNull} from "lodash";

export const LegacyRegisterComponent = (props) => {
	const { profileData } = props;
	return (
		<>
			<DetailsContainer data-test="webRegisterWrapper">
				<IconContainer>
					<Profile />
				</IconContainer>
				<DetailsData>
					<ProfileInformationHeading>User ID</ProfileInformationHeading>
					<UserContributionDetails> {profileData.webAccess && profileData.webAccess.userName} </UserContributionDetails>
				</DetailsData>
			</DetailsContainer>
		</>
	)
}

LegacyRegisterComponent.propTypes = {
  profileData: PropTypes.shape({
    webAccess: PropTypes.shape({
      userName: PropTypes.any
    })
  })
}

const WebRegisterComponent = (props) => {
	const { profileData } = props;
	const checkNotWebregister = () => isNull(profileData.webAccess)

  return (
    <>
    	<ProfileSectionHeading>Web Access Information</ProfileSectionHeading>
			{ checkNotWebregister() ? <NotWebRegister> User is not web registered </NotWebRegister> : <LegacyRegisterComponent profileData={profileData}/>}
    </>
  )
}

WebRegisterComponent.propTypes = {
  profileData: PropTypes.shape({
    webAccess: PropTypes.any
  })
}

export default WebRegisterComponent;